import React, { useEffect, useRef, useState } from 'react'
import { stringifyUrl } from 'query-string'
import { classNames } from '../utils'
import Spinner from './spinner'

function SupplyMode({ endpointUrl, heading, copy, startOverLabel, steps: rawSteps }) {
  const { current: steps } = useRef(JSON.parse(rawSteps))
  const [currentStep, setCurrentStep] = useState(0)
  const [length, setLength] = useState(1)
  const [questions, setQuestions] = useState(steps?.[0] ? [steps?.[0]] : [])
  const [formState, setFormState] = useState({})
  const [response, setResponse] = useState({})
  const [isSubmitting, setIsSubmitting] = useState(false)

  function handleSubmit(payload) {
    setResponse(payload)
  }

  return (
    <>
      {isSubmitting ? <Spinner /> : null}
      <div className="supply-mode__box">
        <h2 className="supply-mode__heading">{heading}</h2>
        <p className="supply-mode__copy">{copy}</p>
        {steps?.length ? (
          <div className="supply-mode__navigation">
            {Array.from(Array(length).keys()).map((step, index) =>
              index <= currentStep ? (
                <div className="supply-mode__navigation-step" key={index}>
                  <button
                    aria-label={step.label}
                    className={classNames(
                      'supply-mode__step-button',
                      Object.values(formState).length - 1 >= index &&
                        'supply-mode__step-button--passed',
                      questions?.[questions.length - 1]?.Options?.length &&
                        'supply-mode__step-button--next-visible',
                      index === length - 1 && 'supply-mode__step-button--last',
                      !index && 'supply-mode__step-button--first'
                    )}
                    onClick={() => setCurrentStep(index)}
                    key={index}
                  >
                    {index + 1}
                  </button>
                  {Object.values(formState)[index] ? (
                    <span>{Object.values(formState)[index]}</span>
                  ) : null}
                </div>
              ) : null
            )}
          </div>
        ) : null}
        {steps?.length ? (
          <div className="supply-mode__steps">
            {questions.map(({ Question, Key, Options }, index) =>
              index === currentStep ? (
                <div className="supply-mode__step" key={Key}>
                  <label htmlFor={Question}>{Question}</label>
                  <select
                    id={Question}
                    className="select"
                    onChange={(e) => {
                      if (!e.target?.value) return
                      const selectedOption = Options.find(
                        (option) => option.Value === e.target.value
                      )
                      if (selectedOption?.Options) {
                        setCurrentStep((prev) => prev + 1)
                        setLength((prev) => prev + 1)
                        setQuestions((prev) => [...prev, selectedOption])
                      } else if (selectedOption?.Cards) {
                        handleSubmit({
                          Cards: selectedOption.Cards
                        })
                      }
                      setFormState((prev) => ({ ...prev, [Key]: e.target?.value }))
                    }}
                    value={formState[Key] || ''}
                  >
                    {Options.map((option) => (
                      <option key={option.Label} value={option.Value} disabled={!option.Value}>
                        {option.Label}
                      </option>
                    ))}
                  </select>
                </div>
              ) : null
            )}
          </div>
        ) : null}
        <button
          className="link supply-mode__start-over"
          onClick={() => {
            setCurrentStep(0)
            setFormState({})
            setResponse({})
            setLength(1)
            setQuestions(steps?.[0] ? [steps?.[0]] : [])
          }}
        >
          {startOverLabel}
        </button>
      </div>
      {response?.Cards?.length > 0
        ? response.Cards.map((groupResponse, index) => (
          <div key={index}>
            <h3 className="supply-mode__results-heading">
              {groupResponse.RecommendedProductsHeading}
            </h3>
            <div className="supply-mode__results-products">
              {groupResponse.RecommendedProducts.map((product) => (
                <article
                  className="supply-mode__results-product"
                  key={product.Id}
                  aria-labelledby={`product-${product.Id}`}
                >
                  {product.Thumbnail ? (
                    <img
                      loading="lazy"
                      width={370}
                      height={370}
                      src={product.Thumbnail}
                      alt={product.Title}
                    />
                  ) : null}
                  <div
                    className={`${
                        product.Urls?.length > 1 ? '' : 'supply-mode__results-product-info'
                      }`}
                  >
                    <div>
                      <h4
                        className="supply-mode__results-product-name"
                        id={`product-${product.Id}`}
                      >
                        {product.Title}
                      </h4>
                      {product.Subheading && (
                        <span className="supply-mode__results-product-subheading">
                          {product.Subheading}
                        </span>
                      )}
                      {product.Copy ? (
                        <div className="supply-mode__results-product-copy rtf" dangerouslySetInnerHTML={{ __html: product.Copy }}></div>
                      ) : null}
                    </div>
                    <div className="supply-mode__results-product-links">
                      {product.Urls?.length > 0
                        ? product.Urls.map((url, index) => (
                          <a key={index} className="btn" href={url.Link} target={url.Target}>
                            {url.Label}
                          </a>
                        ))
                        : null}
                    </div>
                  </div>
                </article>
              ))}
            </div>
          </div>
        ))
        : null}
    </>
  )
}

export default SupplyMode
